const tableHeaderData = [
  {
    label: "E-Id",
    type: "workerId",
    place: "left",
    toolTipText: "Click for Id Sorting"
  },
  {
    label: "Full Name",
    type: "workerFullName",
    place: "left",
    toolTipText: "Click for Name Sorting"
  },
  {
    label: "Date",
    place: "left",
    type: "date",
    toolTipText: "Date"
  },
  {
    label: "Type",
    place: "left",
    type: "regularizedType",
    toolTipText: "IN / OUT / BOTH / OD"
  },

  {
    label: "Location",
    place: "left",
    type: "locationName",
    toolTipText: "locationName"
  },
  {
    label: "Reason",
    place: "left",
    type: "remark",
    toolTipText: "Remark"
  },
  {
    label: "In-Time",
    place: "left",
    type: "inTime",
    toolTipText: "Click for in-time sorting"
  },
  {
    label: "out-Time",
    place: "left",
    type: "outTime",
    toolTipText: "Click for out-time sorting"
  },
  {
    label: "Raised on",
    place: "left",
    type: "createdAt",
    toolTipText: "Click for Date Sorting"
  },
  {
    label: "Status",
    place: "left",
    type: "status",
    toolTipText: "status"
  }
];

const toolTipData = [
  {
    id: "date",
    text: "Select Date."
  },
  {
    id: "locationName",
    text: "Select Location to Get the Users Leave."
  },
  {
    id: "Filter",
    text: "Search by User-id,  Full Name."
  },
  {
    id: "month",
    text: "Select month."
  },
  {
    id: "year",
    text: "Select Year."
  },
  {
    id: "dataType",
    text: "Select Data Type."
  }
];

export { toolTipData, tableHeaderData };
